import { AlgorithmLaunchType } from './../../../shared/enums/LaunchType';
import { itiMessageService } from '@/iti-core-vue';
import algorithmModule from '@/store/modules/algorithm.module';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { validate, ValidationProvider } from 'vee-validate';
import { Field } from '@/shared/dtos/field';
import { ItiIconButton, ItiVHeader } from '@/iti-core-vuetify';
import DxSelectBox from 'devextreme-vue/select-box';
import DxTextBox from 'devextreme-vue/text-box';
import DxNumberBox from 'devextreme-vue/number-box';
import DxTextArea from 'devextreme-vue/text-area';
import DxButton from 'devextreme-vue/button';
import DxDropDownBox from 'devextreme-vue/drop-down-box';
import DxTreeView from 'devextreme-vue/tree-view';
import DxCheckBox from 'devextreme-vue/check-box';
import { DxDataGrid, DxSelection, DxPaging, DxFilterRow, DxScrolling, DxEditing } from 'devextreme-vue/data-grid';
import CustomStore from 'devextreme/data/custom_store';
import DxValidationSummary from 'devextreme-vue/validation-summary';
import { DxValidator, DxRequiredRule, DxCompareRule, DxStringLengthRule, } from 'devextreme-vue/validator';
import { FormattedCategory } from '@/shared/dtos/formatted-category';
import { Categories } from '@/shared/dtos/categories';


@Component({
    components: {
        ValidationProvider,
        ItiIconButton,
        DxSelectBox,
        DxTextBox,
        DxNumberBox,
        DxTextArea,
        DxButton,
        DxValidator,
        DxRequiredRule,
        DxCompareRule,
        DxStringLengthRule,
        DxValidationSummary,
        DxDropDownBox,
        DxTreeView,
        DxCheckBox,
        DxDataGrid,
        DxSelection,
        DxPaging,
        DxFilterRow,
        DxScrolling,
        DxEditing
    },
})

export default class AlgoritmoFormulario extends Vue {
    @Prop() id !: number;
    public loading = false;
    public search = "";
    public treeBoxValue: string[] = [];
    public beforeTreeBoxValue: string[] = [];
    public treeViewName = 'tree-view';
    public selectedCategory = new FormattedCategory();
    public categoriesDescription = "";


    public get editAlgorithm() {
        return algorithmModule.selectedAlgorithm;
    }

    public get categories() {
        return algorithmModule.formattedCategoriesList;
    }

    public get algorithmEditMode() {
        return algorithmModule.algorithmEditMode;
    }

    public get launchTypes() {
        var selectDataSource = Object.keys(AlgorithmLaunchType).map((key: string) => ({
            name: AlgorithmLaunchType[parseInt(key, 10)],
            id: parseInt(key, 10)
        })).filter(x => x.name != undefined);

        return selectDataSource;
    }

    public get algorithmTitle() {
        if (algorithmModule.selectedAlgorithm.moduleName == null || algorithmModule.selectedAlgorithm.moduleName.length == 0) {
            return this.$t('algoritmo.nuevo-algoritmo');
        } else {
            return algorithmModule.selectedAlgorithm.moduleName;
        }
    }

    public created() {
        if (!isNaN(this.id) && this.id != 0) {
            algorithmModule.getAlgorithmById(this.id).then(() => {
                this.assignCategoryDescriptionsToLabel();
            });
            algorithmModule.setAlgorithmEditMode(true);
        }
    }

    public mounted() {
        algorithmModule.getFormattedCategories();
    }
    public async assignCategoryDescriptionsToLabel() {
        if (this.editAlgorithm.categories != null) {
            let listCategories: string[] = [];
            this.editAlgorithm.categories.forEach(element => {
                if (element.categoryFourthLevelId != null) {
                    listCategories.push("4_" + element.categoryFourthLevelId);
                } else if (element.categoryThirdLevelId != null) {
                    listCategories.push("3_" + element.categoryThirdLevelId);
                } else if (element.categorySecondLevelId != null) {
                    listCategories.push("2_" + element.categorySecondLevelId);
                } else if (element.categoryFirstLevelId != null) {
                    listCategories.push("1_" + element.categoryFirstLevelId);
                }
            });
            this.treeBoxValue = listCategories;
            this.showSelectedCategoryExpanded();
        }
    }
    public async saveAlgorithm() {
        itiMessageService.confirm(this.$tc('mensajes-algoritmos.pregunta-guardar'), this.$tc('mensajes.confirmar'), (res) => {
            if (res) {
                this.assignCategoryToAlgorithm();
                algorithmModule.saveAlgorithm(this.editAlgorithm)
                    .then(async () => {
                        await algorithmModule.getAlgorithmById(this.editAlgorithm.id);
                        this.assignCategoryDescriptionsToLabel();
                        if (this.id == 0) this.$router.push({ name: 'AlgoritmoFormulario', params: { id: algorithmModule.selectedAlgorithm.id.toString() } });
                        algorithmModule.setAlgorithmEditMode(true);
                        itiMessageService.toast(this.$tc('mensajes-algoritmos.ok'), 'success', 3000);
                        this.$router.back();
                    })
                    .catch(() => {
                        itiMessageService.toast(this.$tc('mensajes-algoritmos.info-error'), 'error', 2000);
                    });
            }
        });
    }

    public cancelAlgorithm() {
        itiMessageService.confirm(this.$tc('mensajes-algoritmos.pregunta-salir'), this.$tc('mensajes.confirmar'), (res) => {
            if (res) {

                this.$router.push({ name: 'ListaAlgoritmos' });

            }
        });
    }

    public syncTreeViewSelection(e: any) {
        let treeView = (e.component.selectItem && e.component) || (this.$refs[this.treeViewName] && (this.$refs[this.treeViewName] as any).instance);

        if (treeView) {
            if (e.value === null) {
                treeView.unselectAll();
            } else {
                let values = e.value || this.treeBoxValue;
                values && values.forEach(function (value: any) {
                    treeView.selectItem(value);
                });
            }
            this.showSelectedCategoryExpanded();
        } 
    }

    public assignCategoryToAlgorithm() {
        this.editAlgorithm.categories = [];

        this.treeBoxValue.forEach(element => {
            let arr = element.split("_");

            let level = parseInt(arr[0]);
            let id = parseInt(arr[1]);
            switch (level) {
                case 1: {
                    let categories = new Categories();
                    categories.id = 0;
                    categories.categoryFirstLevelId = id;
                    this.editAlgorithm.categories.push(categories);
                    break;
                }
                case 2: {
                    let categories = new Categories();
                    categories.id = 0;
                    categories.categorySecondLevelId = id;
                    this.editAlgorithm.categories.push(categories);
                    break;
                }
                case 3: {
                    let categories = new Categories();
                    categories.id = 0;
                    categories.categoryThirdLevelId = id;
                    this.editAlgorithm.categories.push(categories);
                    break;
                }
                case 4: {
                    let categories = new Categories();
                    categories.id = 0;
                    categories.categoryFourthLevelId = id;
                    this.editAlgorithm.categories.push(categories);
                    break;
                }
            }
        });
    }

    public editAlgorithmParams() {
        algorithmModule.getAlgorithmById(algorithmModule.selectedAlgorithm.id);
        algorithmModule.setAlgorithmEditMode(false);
        this.beforeTreeBoxValue = this.treeBoxValue;
    }

    public setNameLaunch(launchType: any) {
        if (launchType != null) {
            return this.$tc('enum-launch-type.' + launchType.name);
        }
    }

    public formattedContent(contenido: string) {
        if (contenido && contenido.length > 40) {
            return String(contenido).substring(0, 40) + "...";
        } else {
            return contenido;
        }
    }

    public treeView_itemSelectionChanged(e: any) {
        this.treeBoxValue = e.component.getSelectedNodeKeys();
    }

    public onTreeItemClick(e: any) {
        this.selectedCategory = e.itemData;
    }

    public showSelectedCategoryExpanded() {
        this.categories.forEach(element => {
            this.treeBoxValue.forEach(cat => {
                if (element.categoryId == cat) {
                    element.expanded = true;
                    return;
                }
            });
        });
    }

    public get columns() {
        return [
            { dataField: 'key', caption: 'Key' },
            { dataField: 'value', caption: 'Value', dataType: 'string' },
        ]
    }
    public get environmentVariables() {
        return algorithmModule.selectedAlgorithmEnvironmentVariables;
    }

    public createNewEnvironmentVariable() {
        console.log('crear nuevo');
    }
}